import {
  FaIcon,
  ListItem,
  Resource,
  useMarkResourceAsRead,
} from '@fe-learner-common';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';
import { forwardRef } from 'react';
import { buildResourceAriaLabel } from './buildResourceAriaLabel';
import { ResourceActions } from './ResourceActions';
import { ResourceListItemProps } from './ResourceListItem';

export const Detail = forwardRef<
  HTMLButtonElement,
  Omit<ResourceListItemProps, 'container'>
>(
  (
    {
      resource,
      onResourceClick,
      onDescriptionClick,
      participationId,
      texts,
      ...rest
    },
    ref,
  ) => {
    const { mutate: markAsRead } = useMarkResourceAsRead({
      resourceId: resource.rid,
      participationId,
    });
    return (
      <ListItem>
        <button
          type="button"
          ref={ref}
          className="absolute inset-0 z-0 rounded-lg"
          onClick={() => {
            onResourceClick(resource.rid);
            markAsRead();
          }}
          aria-label={buildResourceAriaLabel({
            type: texts.groupTypes[resource.groupType],
            title: resource.material.webTitle,
            tags: resource.tags,
          })}
          {...rest}
        />
        <div className="flex flex-1 items-start justify-between gap-x-4 p-3">
          <Resource
            resourceId={resource.rid}
            title={resource.material.webTitle}
            groupType={resource.groupType}
            thumbnail={resource.material.thumbnail}
            tags={resource.tags}
            isNew={resource.newResource}
            texts={texts}
          />
          <ResourceActions
            resourceId={resource.rid}
            hasDescription={!!resource.material.webDescription}
            onDescriptionClick={onDescriptionClick}
            descriptionAriaLabel={texts.descriptionAriaLabel}
          >
            <button
              type="button"
              className="l-btn l-btn-sm l-btn-tertiary l-icon-btn hover:bg-neutral-50"
              onClick={() => {
                onResourceClick(resource.rid);
              }}
              aria-label={texts.viewResourceAriaLabel}
            >
              <FaIcon width={16} height={16} icon={faArrowRight} />
            </button>
          </ResourceActions>
        </div>
      </ListItem>
    );
  },
);

Detail.displayName = 'DetailListItem';
